/* unplugin-vue-components disabled */import { render } from "./NavActivityCenterEntry.vue?vue&type=template&id=2b8bab8a&scoped=true"
const script = {}

import "./NavActivityCenterEntry.vue?vue&type=style&index=0&id=2b8bab8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8bab8a"]])

export default __exports__